import { render } from "./ClientFilters.vue?vue&type=template&id=c9616aaa"
import script from "./ClientFilters.vue?vue&type=script&lang=js"
export * from "./ClientFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__